import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './VideoGalleryTwin.css';

const VideoGalleryTwin = () => {
  const [hoveredVideo, setHoveredVideo] = useState(null);
  
  const videos = [
    {
      id: '2NadP255KmE',
      title: 'മഞ്ചേരി പാലിയേറ്റീവ് ക്ലിനിക്കും എം ഐ പി രൂപീകരണവും',
      author: 'ഇ അബദുല്‍ മജീദ് പാലപ്പറ്റ'
    },
    {
      id: 'CT4Mfnfr3cM',
      title: 'A Quarter Century of Caring: Dr. Manima`s Unforgettable Palliative Care Stories.',
      author: 'Dr. Manima'
    },
    {
      id: 'WO3CesiqaPo',
      title: 'Exploring the Pariraksha Project and Malappuram`s Palliative Care Efforts',
      author: 'Dr. Mathews Nambeli'
    },
    {
      id: 'bkidBTHDh6I',
      title: 'Palliative Care in Kerala | സാന്ത്വന ചികിത്സയിലെ മലപ്പുറം തിരുത്ത്',
      author: 'Dr. E Divakaran'
    },
    {
      id: 'gxO2PmH9nn0',
      title: 'Team Incubation | Insight | Palliative Care Movement in Kerala',
      author: 'അലി പത്തനാപുരം, ഇ.അബ്ദുല്‍മജീദ് പാലപ്പറ്റ'
    }
  ];

  const handleMouseEnter = (id) => {
    setHoveredVideo(id);
  };

  const handleMouseLeave = () => {
    setHoveredVideo(null);
  };

  return (

    <>
    <h1 className="text-center mb-5 gallery-title">Video Gallery</h1>
    <div className="container py-5 video-gallery">
      
      
      <div className="row">
        {videos.map((video) => (
          <div key={video.id} className="col-md-6 mb-4">
            <div 
              className="video-card card h-100"
              onMouseEnter={() => handleMouseEnter(video.id)}
              onMouseLeave={handleMouseLeave}
            >
              <div className={`video-thumbnail ${hoveredVideo === video.id ? 'hovered' : ''}`}>
                <div className="video-wrapper">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              
              <div className="card-body video-details">
                <h5 className="card-title video-title">{video.title}</h5>
                <p className="card-text video-author">By {video.author}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      
    </div>
    </>
  );
};

export default VideoGalleryTwin;